// Kargo Şablonları penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.shipmentTemplates';

export const inventoryShipmentTemplatesGuide = (t: TFunction): GuideContent => ({
  layout: 'stacked',
  title: t(`${G}.title`, 'Kargo şablonları nasıl yönetilir?'),
  intro: t(`${G}.intro`, 'Bu pencerede pazaryeri gönderilerinde kullanılacak kargo şablonlarını platform bazında yönetirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    form: t(`${G}.regions.form`, 'Yeni şablon ekleme'),
    list: t(`${G}.regions.list`, 'Mevcut kargo şablonları'),
    footer: t(`${G}.regions.footer`, 'Kapat'),
  },
  steps: [
    {
      region: 'form',
      title: t(`${G}.s1.title`, '1. Platformu seçin ve şablon adını yazın'),
      text: t(`${G}.s1.text`, '"Yeni Kargo Şablonu Ekle" bölümünde platformu (N11, Hepsiburada, Trendyol, Amazon veya Diğer) seçin, şablon adını yazın ve "Ekle"ye basın (Enter da çalışır).'),
      tips: [
        t(`${G}.s1.tip1`, 'Şablon adı, pazaryerindeki hesabınızda (Hesabım > Teslimat Bilgilerim) oluşturduğunuz kargo şablonunun adıyla aynı olmalı; ör. BAREM, ÖDEMELİ.'),
        t(`${G}.s1.tip2`, 'Aynı platformda aynı isimde ikinci bir şablon eklenemez.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s2.title`, '2. Şablon listesini inceleyin'),
      text: t(`${G}.s2.text`, '"Mevcut Kargo Şablonları" listesinde her şablon platform etiketi, adı ve oluşturulma tarihiyle görünür. Varsayılan şablon kalın yazılır ve "Varsayılan" etiketi taşır.'),
    },
    {
      region: 'list',
      title: t(`${G}.s3.title`, '3. Varsayılan şablonu belirleyin'),
      text: t(`${G}.s3.text`, 'Varsayılan olarak işaretlenen şablon, o platformun gönderilerinde öncelikli olarak kullanılır. Başka bir şablonu varsayılan yapmak için satırdaki "Varsayılan Yap"a basın.'),
      tips: [
        t(`${G}.s3.tip1`, 'Her platformun yalnız bir varsayılan şablonu olur; yenisini seçince eskisi varsayılanlıktan çıkar.'),
        t(`${G}.s3.tip2`, 'Bir platform için eklenen ilk şablon otomatik olarak varsayılan olur.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s4.title`, '4. Kullanılmayan şablonları silin'),
      text: t(`${G}.s4.text`, 'Satırdaki kırmızı çöp kutusu simgesi şablonu siler. Silme ve varsayılan belirleme işlemleriyle listeyi güncel ve düzenli tutun.'),
      tips: [
        t(`${G}.s4.tip1`, 'Silme onay sormadan hemen uygulanır; doğru satırı seçtiğinizden emin olun.'),
      ],
    },
  ],
});
